import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import MetricCard from 'components/common/MetricCard';
import { truncateIntegerNumber } from 'services/valueFormatter';
import api from 'services/api';

const initialMetrics = {
  queueSize: { value: 0, variation: 0 },
  inputRate: { value: 0, variation: 0 },
};

const variation = (newValue, oldValue) => {
  if (oldValue === 0) {
    return 0;
  }

  return ((newValue - oldValue) / oldValue) * 100;
};

const LiveActivityMetrics = ({ loggerId, onError }) => {
  const [metrics, setMetrics] = useState(initialMetrics);
  const previousMetrics = useRef(initialMetrics);

  useEffect(() => {
    previousMetrics.current = initialMetrics;
    setMetrics(initialMetrics);

    const fetchLiveActivity = () => {
      api.getLiveActivity(loggerId, (res) => {

        if (res.data.status !== 200) {
          onError();
          return;
        }

        const queueSize = res.data.metrics.queueSize.value;
        const previousQueueSize = previousMetrics.current.queueSize.value;
        const inputRate = previousMetrics.current === initialMetrics
          ? 0
          : (queueSize - previousQueueSize) / 5;
        const previousInputRate = previousMetrics.current.inputRate.value;
        const nextMetrics = {
          queueSize: {
            value: queueSize,
            variation: variation(queueSize, previousQueueSize),
          },
          inputRate: {
            value: inputRate,
            variation: variation(inputRate, previousInputRate),
          },
        };

        previousMetrics.current = nextMetrics;
        setMetrics(nextMetrics);
      });
    };

    fetchLiveActivity();
    const interval = setInterval(fetchLiveActivity, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [loggerId, onError]);

  return (
    <>
      <div className="column is-half-widescreen is-half-desktop">
        <MetricCard
          icon="fa-layer-group"
          title="Processing Queue Size"
          value={truncateIntegerNumber(metrics.queueSize.value)}
          variation={metrics.queueSize.variation}
        />
      </div>
      <div className="column is-half-widescreen is-half-desktop">
        <MetricCard
          icon="fa-tachometer-alt"
          title="Input Rate"
          value={truncateIntegerNumber(metrics.inputRate.value)}
          variation={metrics.inputRate.variation}
        />
      </div>
    </>
  );
};

LiveActivityMetrics.propTypes = {
  loggerId: PropTypes.string,
  onError: PropTypes.func.isRequired,
};

export default LiveActivityMetrics;
